import React from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { ReactComponent as CancelIcon } from '../../Assets/Icons/cancel.svg';
import { useNavigate } from 'react-router-dom';
import signupListner from '../../Assets/Images/admin.png';
import signupCorporate from '../../Assets/Images/employee.png';
import { resetOtpState } from '../../Storeredux/actions';
import { useDispatch } from 'react-redux';

function RegisterModal(props: any) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleNavigation = (data: string) => {
    dispatch(resetOtpState());
    navigate('register', { state: { userData: data } });
    props.onHide();
  };
  return (
    <Transition appear show={props.isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={props.onHide}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className="w-full transform overflow-hidden lg:max-w-[40%] xl:max-w-[40%] rounded-2xl bg-white text-left align-middle shadow-xl transition-all">
                <div className='flex justify-end px-4 py-2'>
                  <CancelIcon onClick={props.onHide} className='cursor-pointer' />
                </div>
                <div className={'flex flex-col gap-5 px-5'}>
                  <div>
                    <h1 className={'font-bold text-2xl'}>
                      Who Are You Registering As?
                    </h1>
                    <p className={'text-sm text-custom-darkgreen'}>
                      Choose your role to get started and access tailored features.
                    </p>
                  </div>
                  <div className='lg:flex lg:gap-6 justify-center p-14'>
                    <div onClick={() => handleNavigation('admin')}
                         className='block bg-[#F3F3F3] cursor-pointer register-card rounded-lg p-4 md:mb-10 mb-10 lg:mb-0 w-full hover:bg-custom-midnightgreen hover:text-white '
                    >
                      <div>
                        <img src={signupListner} alt='Sign Up Admin'
                             className='mx-auto lg:max-w-[35%] ' />
                      </div>
                      <h1 className='text-xl font-semibold py-5 text-center'>
                        Admin
                      </h1>
                    </div>
                    <div onClick={() => handleNavigation('employee')}
                         className='block bg-[#F3F3F3] cursor-pointer register-card rounded-lg p-4 md:mb-10 mb-10 lg:mb-0 w-full hover:bg-custom-midnightgreen hover:text-white overflow-hidden'>
                      <div>
                        <img src={signupCorporate} alt="Sign Up Employee"
                             className="mx-auto lg:max-w-[35%] " />
                      </div>
                      <h1 className="text-xl text-center font-semibold py-5">
                        Employees
                      </h1>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}

export default RegisterModal;
